// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2xVN1","actions":"GroupTable_actions__3o3gE","deleteModalFooter":"GroupTable_deleteModalFooter__1USpC"};